module.exports = __webpack_public_path__ + "static/media/home.4aea08a4.svg";